<template>

<fragment>

<core-filter-advanced-builder-logic :logic="rule.logic" :is-first="index === 1" v-on:change="onLogicChange" />

<div class="rule" :class="{'is-over': is.over}" v-tooltip="(expanded) ? false : 'Manage rule'" v-on:click="onClick" v-on:mouseenter="onMouseEnter" v-on:mouseleave="onMouseLeave" v-click-outside="onOutsideClick">

    <div class="rule-text">
    
        {{ text }}
    
    </div>

    <div class="rule-button">
    
        <i class="fa-solid fa-ellipsis-vertical" />
    
    </div>

    <core-filter-advanced-builder-dropdown :options="options" class="rule-dropdown" v-on:change="onDropdownClick" v-if="expanded" />
	
</div>

</fragment>

</template>

<script>

import vClickOutside from 'v-click-outside'
import $filter from '@/filter'

export default {

	directives: {
		clickOutside: vClickOutside.directive
	},

    props: ['rule', 'level', 'index'],

    data: function() {

        return {
            expanded: false,
            is: {
                over: false
            },
            text: ''
        }

    },

    mounted: async function() {

        await this.refreshText()

    },

    watch: {

        rule: {
            deep: true,
            handler: async function() {

                await this.refreshText()

            }
        }

    },

    computed: {

        options: function() {

            var options = [
                { value: 'rule.change', text: 'Modify rule' },
                { value: 'rule.remove', text: 'Remove rule' }
            ]

            if (this.level < 4) {

                options.push({ value: 'group.convert', text: 'Convert to group' })

            }

            return options

        }

    },

    methods: {

        refreshText: async function() {

            this.text = await $filter.summarise(this.rule, this.$route)

        },

        onLogicChange: function(value) {

            this.$pubsub.$emit('filter.logic.change', {
                id: this.rule.id,
                logic: value
            })

        },

        onDropdownClick: function(value) {

            if (value === 'rule.change') {

                this.$pubsub.$emit('open.modal', {
                    id: 'filterRule',
                    model: this.$util.copy(this.rule)
                })

            } else if (value === 'rule.remove') {

                this.$pubsub.$emit('filter.rule.remove', {
                    id: this.rule.id
                })

            } else if (value === 'group.convert') {

                this.$pubsub.$emit('filter.group.convert', {
                    id: this.rule.id
                })

            }

            this.expanded = false
            this.is.over = false

        },

        onOutsideClick: function() {

            this.expanded = false

        },

        onClick: function() {

            this.expanded = !this.expanded

        },

        onMouseEnter: function() {

            this.is.over = true
            
        },

        onMouseLeave: function() {

            this.is.over = false

        }

    }

}

</script>

<style scoped>

.rule {
    min-height: 40px;
    display: grid;
    grid-gap: 2px;
    grid-template-columns: 1fr 40px;
    cursor: pointer;
}

.rule-text {
    display: flex;
    align-items: center;
    user-select: none;
    font-size: 14px;
    line-height: 16px;
    padding: 4px 10px;
    color: #fff;
    border-radius: 10px 0px 0px 10px;
    font-weight: 400;
    background-color: rgba(255, 255, 255, 0.15);
}

.is-mobile .rule-text {
    background-color: #4B7185;
}

.is-mobile .group[data-level="2"] .rule-text,
.is-mobile .group[data-level="3"] .rule-text,
.is-mobile .group[data-level="4"] .rule-text {
    background-color: rgba(255, 255, 255, 0.15);
}

.is-desktop .rule.is-over .rule-text {
    background-color: #082534;
}

.rule-button {
    width: 40px;
    height: 100%;
    user-select: none;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.15);
    color: rgba(255, 255, 255, 0.75);
    border-radius: 50%;
    border-radius: 0px 10px 10px 0px;
}

.is-mobile .rule-button {
    background-color: #4B7185;
}

.is-mobile .group[data-level="2"] .rule-button,
.is-mobile .group[data-level="3"] .rule-button,
.is-mobile .group[data-level="4"] .rule-button {
    background-color: rgba(255, 255, 255, 0.15);
}

.is-desktop .rule.is-over .rule-button {
    background-color: #082534;
    color: #fff;
}

</style>
